import {message} from "antd";
import {useCreateUserScheduleApi} from "../../../../../react-query-hooks/schedule";
import {CreateUserScheduleApiResponse} from "../../../../../react-query-hooks/schedule/types";
import {CreateUserScheduleFormValues} from "../components/schedules-header/create-schedule-form/schema-validation";
import {createUserScheduleDto} from "../create-user-schedule-service";

interface CreateUserScheduleHookResult {
  createUserSchedule(values: CreateUserScheduleFormValues): void;
  wasUserScheduleCreated: boolean;
  isCreatingUserSchedule: boolean;
  responseData?: CreateUserScheduleApiResponse;
}

export function useCreateUserScheduleHook({
  closeModal,
}: {
  closeModal(): void;
}): CreateUserScheduleHookResult {
  const createUserScheduleMutation = useCreateUserScheduleApi();

  const createUserSchedule = (values: CreateUserScheduleFormValues) => {
    createUserScheduleMutation.mutate(createUserScheduleDto(values), {
      onSuccess(data) {
        message.success("Your schedule has been created successfully successfully");
        closeModal();
      },
    });
  };
  return {
    createUserSchedule,
    wasUserScheduleCreated: createUserScheduleMutation.isSuccess,
    isCreatingUserSchedule: createUserScheduleMutation.isLoading,
    responseData: createUserScheduleMutation.isSuccess
      ? createUserScheduleMutation.data.data
      : undefined,
  };
}
